import { TransactionJournalEntry } from "../../types/transaction";
import {
    TransactionDto,
    TransactionDtoInput,
} from "../transactions/transaction.dto";

export class TransferPreviewTransactionDto extends TransactionDto {
    journalEntries?: TransactionJournalEntry[];

    constructor(transaction: TransactionDtoInput) {
        super(transaction);

        this.journalEntries = transaction.journalEntries?.map(
            ({
                id,
                accountId,
                lineOrder,
                referenceNumber,
                accountingLedger,
            }) => ({
                id,
                accountId,
                lineOrder,
                referenceNumber,
                accountingLedger: {
                    id: accountingLedger.id,
                    entityId: accountingLedger.entityId,
                    basis: accountingLedger.basis,
                },
            }),
        );
    }
}
